export default () => {
	const form = document.querySelector('[data-form="magazyny"]')

	if (!form) return

	const offerIdInput = form.querySelector('input[name=offer_id]')
	if (form.querySelector('select[name=sort_by]'))
		form.querySelector('select[name=sort_by]').addEventListener('change', () => {
			var evt = new Event('submit',
				{'view': window, 'bubbles': true, 'cancelable': true});
			form.dispatchEvent(evt);
		});

	if (offerIdInput)
		offerIdInput.addEventListener('change', (e) => {
			if (e.currentTarget.value) {
				if (form.elements)
					Array.from(form.elements).forEach((el) => {
						if (el.required) {
							el.dataset.required = true;
						}
						el.required = false;
					});
			} else {
				if (form.elements)
					Array.from(form.elements).forEach((el) => {
						if (el.dataset.required) {
							el.required = true;
						}
						el.dataset.required = null;
					});
			}
		});

	form.addEventListener("submit", (e) => {
		e.preventDefault()

		let queryStringItems = [];
		let queryString = '';

		if(!offerIdInput.value) {

			Array.from(e.target.elements).forEach((el) => {

				if (el.getAttribute('name') && el.value) {
					if (el.getAttribute('name') == 'name_pl') {
						const existingOption = form.querySelector('#location_list option[value="' + el.value + '"]');
						if (existingOption && existingOption.dataset.locationId) {
							queryStringItems.push('locations=' + existingOption.dataset.locationId);
						}
					} else if (el.getAttribute('name') == 'max_total_area' || el.getAttribute('name') == 'min_total_area' || el.getAttribute('name') == 'minimum_module_sqm') {
						if (parseInt(el.value) > 0)
							queryStringItems.push(el.getAttribute('name') + '=' + parseInt(el.value));
					} else {
						if (el.value)
							queryStringItems.push(el.getAttribute('name') + '=' + el.value);
					}
				}
			})

			queryString = queryStringItems.join("&");

			const sortSelect = document.querySelector('select[name=sort_by]');

			if (sortSelect && sortSelect.value) {
				queryString += '&sort_by=' + sortSelect.value;
			}
		} else {
			queryString = 'offer_id=' + offerIdInput.value;
		}


		let {origin, pathname} = window.location

		const lang = document.querySelector('html').getAttribute('lang').substr(0, 2);

		var newPath = pathname;
		if (newPath == '/') {
			newPath += (lang != 'pl' ? lang : '');
			switch (lang) {
				case 'pl':
					newPath += 'magazyny/';
					break;
				default:
					newPath += 'warehouse-spaces/';
					break;

			}
		}

		if (queryString) {
			queryString = '?s=&post_type=magazyny&' + queryString;
		}

		console.log(`${origin}${newPath}${queryString}`);
		window.location.href = `${origin}${newPath}${queryString}`
	})


}
